import React from 'react';
import { Form, FormFeedback, Input } from 'reactstrap';

// Formik validation
import { useFormik } from "formik";
import moment from 'moment';
import * as Yup from "yup";

import { BaseCustomButton, BaseCustomModal, GradientDecorationLine } from '../../../../shared';

export const AddFinalReportModal = ({ props, setShowModal, showModal, modalHeader, modalClose, modalRespInfo, rowInfo, isUpdate, datedAt }) => {

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            // id: isUpdate ? rowInfo?.id ? rowInfo.id : '' : '',
            description: isUpdate ? rowInfo?.description ? rowInfo.description : '-' : '-',
            datedAt: (moment().format('YYYY-MM-DD')),
            deliveryDatedAt: (moment().format('YYYY-MM-DD')),
            supportedDocumentation: isUpdate ? rowInfo?.supportedDocumentation ? rowInfo.supportedDocumentation : '' : '',
        },
        validationSchema: Yup.object({
          description: Yup.string().required("Ingrese la descripción del reporte final"),
        //   deliveryDatedAt: Yup.string().required("Ingrese la fecha"),
          supportedDocumentation: Yup.string().required("Ingrese la documentación"),
        }),
        onSubmit: (values, { resetForm }) => {
            modalRespInfo(values)
            resetForm()
            setShowModal(false)
            // dispatch(loginUser(values, props.history));
        }
    });

    const { className } = props;
    const toggle = () => {
        setShowModal(!showModal);
    }

    const onClosed = () =>{
        validation.resetForm();
        modalClose();
        setShowModal(false)
    }

    const buttons = (
        <div className="page-title-box d-flex justify-content-end">
            <BaseCustomButton
                color='success'
                className='rounded-3 me-2'
                onClick={validation.handleSubmit}
                label='Guardar'
                outline={true}
                icon="mdi mdi-content-save me-1"
            />
            <BaseCustomButton
                color='danger'
                className='rounded-3 me-3'
                onClick={toggle}
                label='Cancelar'
                outline={true}
                icon="mdi mdi-close-circle me-1"
            />
        </div>
    );

    const title = (
        <div className="d-flex ms-3 p-0">
            <label className="m-0 p-0">
                <h4 className="text-primary m-0 ps-4">{modalHeader}</h4>
            </label>
        </div>
    );


    return (
        <>
            <BaseCustomModal
                title={title}
                isModalOpen={showModal}
                handleCancel={toggle}
                onClosed={onClosed}
                centered
                zIndex={9999}
                width="80%"
                className={className}
                footer={buttons}
            >
                <GradientDecorationLine />

                <Form
                    className="form-horizontal mt-3 mb-1"
                    onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                    }}
                >
                    <div className="row mx-4 my-3">
                        <div className="col-3 col-md-12">
                            <label className="text-primary ml-1">Descripción de informe final</label>
                            <div className="w-100 me-3">
                                <Input
                                    required
                                    name="description"
                                    className="form-control rounded-3 text-primary"
                                    type="text"
                                    value={validation.values.description}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.description && validation.errors.description}
                                />
                                {validation.touched.description && validation.errors.description && (
                                    <FormFeedback type="invalid">{validation.errors.description}</FormFeedback>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="row mx-4 my-3">
                        <div className="col-3 col-md-12">
                            <label className="text-primary ml-1">Fecha de Entrega de Informe</label>
                            <div className="w-100 me-3">
                                <Input
                                    required
                                    disabled={true}
                                    name="datedAt"
                                    className="form-control rounded-3 text-primary"
                                    value={validation.values.datedAt}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.datedAt && validation.errors.datedAt}
                                />
                                {validation.touched.datedAt && validation.errors.datedAt && (
                                    <FormFeedback type="invalid">{validation.errors.datedAt}</FormFeedback>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="row mx-4 my-3">
                        <div className="col-3 col-md-12">
                            <label className="text-primary ml-1">Fecha de Entrega de Informe Real</label>
                            <div className="w-100 me-3">
                                <Input
                                    required
                                    disabled={true}
                                    name="deliveryDatedAt"
                                    className="form-control rounded-3 text-primary"
                                    value={validation.values.deliveryDatedAt}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.deliveryDatedAt && validation.errors.deliveryDatedAt}
                                />
                                {validation.touched.deliveryDatedAt && validation.errors.deliveryDatedAt && (
                                    <FormFeedback type="invalid">{validation.errors.deliveryDatedAt}</FormFeedback>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="row mx-4 my-3">
                        <div className="col-3 col-md-12">
                            <label className="text-primary">Documentación Soporte</label>
                            <Input
                                required
                                name="supportedDocumentation"
                                className="form-control text-primary"
                                placeholder="Documentación Soporte"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.supportedDocumentation || ""}
                                invalid={
                                    validation.touched.supportedDocumentation &&
                                    validation.errors.supportedDocumentation
                                }
                            />
                            {validation.touched.supportedDocumentation &&
                                validation.errors.supportedDocumentation && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.supportedDocumentation}
                                    </FormFeedback>
                                )}
                        </div>
                    </div>

                    <div className="mt-5">
                        <GradientDecorationLine />
                    </div>
                </Form>
            </BaseCustomModal>
        </>
    )
}
